import { FC } from "react";

import { Planner } from "./Planner";

import { CloseOverlayButton } from "components/materials/sidebar/CloseOverlayButton";
import { ContentSidebarHeader } from "components/materials/sidebar/ContentSidebarHeader";
import { ContentSidebarMain } from "components/materials/sidebar/ContentSidebarMain";
import { OverlayContainer } from "components/materials/sidebar/OverlayContainer";
import { getSidebarHeader } from "helpers/sidebar";
import { HorizontalDivider } from "mds/components/HorizontalDivider";
import { IconText } from "mds/components/IconText";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { ContactsIcon } from "mds/icons";
import { CONTENT_SIDEBAR_TAB_NAME } from "utils/urls";

interface PlannerSidebarPanelProps {
  scrollTrackingId?: string;
}

export const PlannerSidebarPanel: FC<PlannerSidebarPanelProps> = ({ scrollTrackingId }) => {
  const isMobile = !useIsMdOrLarger();

  if (isMobile) {
    return (
      <OverlayContainer className="bg-black-tint-97">
        <ContentSidebarHeader panelType="overlay" visibleOnMobile>
          <IconText
            iconStart={<ContactsIcon className="text-blue" />}
            text={getSidebarHeader(CONTENT_SIDEBAR_TAB_NAME.Planner)}
          />
          <CloseOverlayButton />
        </ContentSidebarHeader>
        <ContentSidebarMain>
          <Planner showAll />
        </ContentSidebarMain>
      </OverlayContainer>
    );
  }

  return (
    <>
      <ContentSidebarHeader className="flex-col">
        {getSidebarHeader(CONTENT_SIDEBAR_TAB_NAME.Planner)}

        <HorizontalDivider className="my-3 -ml-3" />
      </ContentSidebarHeader>

      <ContentSidebarMain className="h-full" scrollTrackingId={scrollTrackingId}>
        <Planner showAll />
      </ContentSidebarMain>
    </>
  );
};
